<template>
  <vue-iframe
    :src="src"
    frame-id="my-ifram"
    @load="onLoad"
    name="my-frame"
    width="150px"
    height="200px"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {

  name: "Mcap",
  data() {
    return {
      myIframe: null,
    };
  },
  computed: {
    ...mapGetters({getToken:"getToken"}),
    src() {
      return `${process.env.VUE_APP_DOMAIN_URL}${process.env.VUE_APP_IFRAME_ENDPOINT}mcap/?auth_token=`+this.getToken;
    },
  },
  methods: {
    onLoad(frame) {
      this.myIframe = frame.contentWindow;
    },
  },
};
</script>

<style></style>
